import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { PayoutDialog } from './payout.dialog';
import { environment } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'withdraw-muchbetter-component',
  templateUrl: '../sharedTemplates/withdraw-muchbetter.component.html',
})
export class WithdrawMuchBetterComponent {
  coinbaseWithdrawDatas: UntypedFormGroup;
  coinbaseDataRaw: any;
  MinValue: any;
  MaxValue: any;

  @Output() dataChangedCallback = new EventEmitter<any>();

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.getWithDrawInfo();
    });

    this.coinbaseWithdrawDatas = _FormBuilder.group({
      withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(200), Validators.maxLength(10)]),
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('MuchBetter', true);
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  getWithDrawInfo() {
    this._ApiService.getWithDrawDepositControl3().then(result => {
      //console.log("getDeposit--",result.filter(item => item.DepositTypeId == this.DepositTypeId));

      const WithDrawInfo = result;

      this.MinValue = WithDrawInfo[0].MinValue;
      this.MaxValue = WithDrawInfo[0].MaxValue;
      if (WithDrawInfo.length > 0) {
        this.coinbaseWithdrawDatas.controls.withdrawamount.setValue('');
        // this.coinbaseWithdrawDatas = this._FormBuilder.group({

        //   withdrawamount: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(5), Validators.min(this.MinValue), Validators.max(this.MaxValue)])
        // });

        this.coinbaseWithdrawDatas.valueChanges.subscribe(x => {
          this.coinbaseDataRaw = x;
        });
      }
    });
  }

  submitCoinbaseWithdrawData() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.withdrawMuchBetter(this.coinbaseDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      ////console.log("COIN_BASE_WITHDRAW", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          this.openPayoutDialog();

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');

          this.coinbaseWithdrawDatas.patchValue({ withdrawamount: '' });
          if (this._UserHelper.customerUser.CustomerId) {
            this._ApiService.getClient2().then().catch();
          }
        }
      }

      this.dataChangedCallback.emit(true);
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
